var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.99442,
    height: 31.99429,
    viewBox: "0 0 39.99442 31.99429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M19.99921,24.99929c-4.69709-.0056-8.59372-3.63525-8.93215-8.32014l-6.55611-5.06608c-.87877,1.07851-1.64729,2.24234-2.29404,3.47406-.28981.57347-.28981,1.25056,0,1.82403,3.36986,6.74668,10.24104,11.03123,17.78229,11.08818,1.64384-.01103,3.27962-.23079,4.86808-.65401l-3.24405-2.51004c-.53526.10375-1.07884.15864-1.62403.164ZM39.61353,28.63135l-6.91011-5.34009c2.0989-1.76905,3.82506-3.93781,5.07808-6.38011.28981-.57347.28981-1.25056,0-1.82403-3.36986-6.74668-10.24104-11.03122-17.78229-11.08818-3.2153.0051-6.37817.81507-9.20015,2.35604L2.84093.20888c-.43556-.33671-1.06135-.25804-1.40002.176L.20888,1.96491c-.33671.43556-.25804,1.06135.176,1.40002l36.77261,28.42047c.43556.33671,1.06136.25804,1.40002-.176l1.22802-1.58003c.33671-.43556.25804-1.06135-.176-1.40002l.00399.002ZM28.13134,19.75521l-2.45604-1.89803c1.06877-3.09113-.57067-6.4634-3.6618-7.53218-1.16004-.40109-2.41605-.43182-3.59432-.08795.376.51061.5792,1.12791.58001,1.76203-.00932.21086-.04151.42009-.096.62401l-4.60008-3.55606c1.59808-1.33486,3.61386-2.06671,5.69609-2.06803,4.97064,0,9.00015,4.0295,9.00015,9.00015h0c-.00771,1.30084-.30419,2.58374-.86801,3.75606Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.137769155c77c19c280f5595c153a96f.svg";
export { ForwardRef as ReactComponent };